var m = require('mithril')
var prop = require('mithril/stream')
var telegraph = require('../../libs/Telegraph');
var key = require('../../libs/keybindings');
var auth = require('../../auth/models/session');
var EventEmitter = require('events').EventEmitter;

var edit = new EventEmitter();

telegraph(edit);

edit.vm = {
  editing : prop(false),
  toggle : function (event) {
    if (event) {
      event.preventDefault();
    }
    if (auth.user().isSuperuser == 1) {
      edit.vm.editing() ? edit.emit('exit') : edit.emit('enter');
	    edit.vm.editing(!edit.vm.editing());
      edit.emit('toggle');
    }
  }
}

key.setScope('home');
key.unbind('e', 'all');
key.unbind('e', 'home');
key('e', 'home', function () {
	if (auth.user().isSuperuser == 1) {
		edit.vm.toggle();
		m.redraw();
	}
})

module.exports = edit;
